import { render, staticRenderFns } from "./integralRuleList.vue?vue&type=template&id=71c31d9c&scoped=true"
import script from "./integralRuleList.vue?vue&type=script&lang=js"
export * from "./integralRuleList.vue?vue&type=script&lang=js"
import style0 from "./integralRuleList.vue?vue&type=style&index=0&id=71c31d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c31d9c",
  null
  
)

export default component.exports